module.exports = __webpack_public_path__ + "static/fonts/lynkcotype-medium.e5578469.otf";